import { render, staticRenderFns } from "./FormDashboardSelect.vue?vue&type=template&id=0b277e1e&scoped=true&"
import script from "./FormDashboardSelect.vue?vue&type=script&lang=js&"
export * from "./FormDashboardSelect.vue?vue&type=script&lang=js&"
import style0 from "./FormDashboardSelect.vue?vue&type=style&index=0&id=0b277e1e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b277e1e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/circleci/project/frontend/admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0b277e1e')) {
      api.createRecord('0b277e1e', component.options)
    } else {
      api.reload('0b277e1e', component.options)
    }
    module.hot.accept("./FormDashboardSelect.vue?vue&type=template&id=0b277e1e&scoped=true&", function () {
      api.rerender('0b277e1e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/form/FormDashboardSelect.vue"
export default component.exports